export default __webpack_public_path__ + "resources/icons/n112-c6c8.png";